import { useState } from 'react'

import { Button } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { motion } from 'framer-motion'
import { createPortal } from 'react-dom'

const getIsShown = () => localStorage.getItem('cookie-accepted') !== 'true'

export function CookieNoticeProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [shown, setShown] = useState(getIsShown)

  const handleConfirm = () => {
    localStorage.setItem('cookie-accepted', 'true')
    setShown(false)
  }

  return (
    <>
      {children}{' '}
      {shown ? (
        createPortal(
          <motion.div
            animate={{ bottom: 32 }}
            initial={{ bottom: -256 }}
            style={{
              position: 'fixed',
              right: '50%',
              bottom: 32,
              transform: 'translateX(50%)',
              border: '2px #0034AD solid',
              backgroundColor: '#fff',
              borderRadius: '8px',
              zIndex: 1250,
              width: '25vw',
              minWidth: '320px',
              marginLeft: '32px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              gap: '8px',
              padding: '6px',
              boxShadow: '0 0 4px 2px #0034AD40',
            }}
            transition={{ duration: 0.3, ease: 'circOut' }}
          >
            <Box
              sx={{
                backgroundColor: '#fff',
                borderRadius: '8px',
                padding: '8px',
              }}
            >
              <Typography
                sx={{
                  color: '#333',
                  fontSize: '16px',
                  fontWeight: '400',
                  lineHeight: '24px',
                }}
              >
                BuildDocs использует cookie для улучшения работы сайта.
                Продолжая пользоваться сервисом, вы соглашаетесь на их
                использование.
                <br />
                <br />
                Подробнее — в Политике использования файлов cookie
              </Typography>
            </Box>
            <Button
              sx={{
                bgcolor: '#0034AD',
                px: 2,
                color: 'white',
                '&:hover': { bgcolor: '#002E9C' },
              }}
              onClick={handleConfirm}
            >
              Принять
            </Button>
          </motion.div>,
          document.body,
        )
      ) : (
        <></>
      )}
    </>
  )
}
